import React from 'react';
import { LocationSelectedEvent, Suburb } from '../models';
import { setConfiguratorPostcode } from '../services/dxp-postcode-service';

const SUBURB_KEY = 'suburb';

export const usePostcode = () => {
  const defaultSuburb: Suburb = {
    name: 'Sydney',
    fullName: 'Sydney, NSW 2000',
    state: 'NSW',
    postcode: '2000',
  };

  const [suburb, setSuburb] = React.useState<Suburb>(() => {
    try {
      const stored = localStorage.getItem(SUBURB_KEY);
      return stored ? JSON.parse(stored) : defaultSuburb;
    } catch {
      return defaultSuburb;
    }
  });

  const locationSelected = React.useCallback((event: LocationSelectedEvent) => {
    const newSuburb = event.detail?.suburb;

    if (newSuburb && newSuburb.name && newSuburb.postcode && newSuburb.state) {
      const suburbData = {
        ...newSuburb,
        fullName: `${newSuburb.name}, ${newSuburb.state} ${newSuburb.postcode}`,
      };

      setSuburb(suburbData);
      localStorage.setItem(SUBURB_KEY, JSON.stringify(suburbData));
      setConfiguratorPostcode(suburbData.postcode).then(() => {
        const param = { detail: { suburb: suburbData } };
        window.dispatchEvent(new CustomEvent('dealerChanged', param));
      });
    } else {
      console.warn('Invalid suburb received:', newSuburb);
    }
  }, []);

  React.useEffect(() => {}, [suburb]);

  React.useEffect(() => {
    window.addEventListener('locationSelected', locationSelected);
    return () => {
      window.removeEventListener('locationSelected', locationSelected);
    };
  }, [locationSelected]);

  const showPostcodeSelect = () => {
    window.dispatchEvent(new CustomEvent('selectLocation', { detail: {} }));
  };

  return { ...suburb, showPostcodeSelect };
};
